// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZaKQ","colBig":"styles_colBig__1c65g","colSmall":"styles_colSmall__3hHgA","shopifyNameWrapper":"styles_shopifyNameWrapper__1Udfl"};